// extracted by mini-css-extract-plugin
module.exports = {"gm-style":"dJq7uM"};